<template>
    <div class="tw-w-full tw-bg-white tw-py-10 tw-px-4 ">

        <div class="tab-view-container tw-w-full tw-flex tw-flex-col " :class="{ 'animate-slide-up': isVisible }">
            <span class="tw-w-full tw-text-center tw-text-xl tw-font-bold tw-text-textMain tw-mb-4 "
                v-html="$t('首页解决方案标题')"></span>
            <span class="tw-w-full tw-text-center tw-text-sm  tw-text-textDisabled tw-mb-6 ">{{ $t('首页解决方案介绍')
            }}</span>


            <div class="tw-grid tw-grid-cols-2 tw-gap-4">
                <div class="tw-relative tw-h-48" v-for="(item, index) in tabsList" :key="index">
                    <img class="tw-w-full tw-h-full tw-p-0.5 tw-object-cover tw-absolute tw-top-0 tw-left-0"
                        :src="item.mainImg" :alt="item.name">

                    <div class="card-content tw-flex tw-flex-col tw-absolute  tw-p-3 tw-z-20 tw-w-full tw-h-full">

                        <span class="tw-flex-none  tw-text-base tw-font-medium tw-text-textMain fontstylewrapmore-2">{{
                            item.name
                            }}</span>

                        <div class="tw-flex tw-flex-col tw-flex-1 tw-justify-end tw-w-full">

                            <span class="fontstylewrapmore-3 tw-mt-3 tw-text-sm tw-text-textDisabled">{{
                                item.intro }}</span>
                            <span @click.stop="handleClickRoute(item)"
                                class="tw-mt-2 tw-py-1 tw-w-full tw-text-sm tw-text-center tw-rounded-sm  tw-bg-primary tw-text-white tw-cursor-pointer">立即咨询</span>
                        </div>


                    </div>
                </div>
            </div>



            <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-mt-5">
                <span class="tw-text-textLight tw-text-center tw-text-sm tw-cursor-pointer tw-py-1 tw-px-4 tw-border  tw-rounded-sm
           hover:tw-text-primary hover:tw-border-primary" @click="handleClickRoute">
                    {{ $t('更多产品') }}
                    <b-icon icon="chevron-right" class="tw-w-3 tw-h-3 "></b-icon>

                </span>
            </div>

        </div>
    </div>
</template>

<script>
import { solutionsApi } from "@/api/modules/home";
import BigImg from "@/components/skeleton/bigImg.vue";
export default {
    name: 'mobileSchemeView',
    components: {
        BigImg
    },
    data() {
        return {
            tabsList: [],
            isLoading: true,
            isVisible: false,
            observer: null,

        };
    },
    mounted() {
        const info = JSON.parse(localStorage.getItem('indexInfo'));
        if (info) {
            this.getList();
        }
        this.$nextTick(() => {
            setTimeout(() => {
                this.initIntersectionObserver();
            }, 500);
        });
    },
    methods: {
        initIntersectionObserver() {

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.isVisible) {

                        this.isVisible = true;
                        // 动画只执行一次，所以可以断开观察器
                        this.observer.disconnect();
                    }
                });
            }, {
                threshold: 0, // 当组件10%可见时触发
            });

            this.observer.observe(this.$el);
        },
        getList() {
            solutionsApi({
                pageIndex: 1,
                pageSize: 5,
            }).then((res) => {
                this.tabsList = res.data.list || [];
            })
        },
        handleClickRoute(row) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            if (row.id) {
                localStorage.setItem("detailForm", JSON.stringify(row))
                this.$router.push({
                    path: '/solution/' + row.id + "?isApi=false"
                });
            } else {
                this.$router.push({
                    path: '/solution'
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.tab-view-container {
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
    opacity: 1;
    transform: translateY(0);
}

.flex-1 {
    flex: 1;
}

.flex-start {
    display: flex;
    justify-content: flex-start;
}

.solution-container {
    display: flex;
}

.solution-item {
    display: flex;
    height: 400px;
    margin: 10px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;
    border-radius: 0;

    &:hover {
        cursor: pointer;
        transform: translateY(-3px);
    }
}

.solution-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.solution-content {
    position: absolute;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #fff;
    height: 100%;
}

.solution-title {
    font-size: 20px;
    margin-bottom: 10px;
}

.solution-desc {
    font-size: 14px;
    margin-bottom: 10px;
}

.solution-link {
    color: #007bff;
    text-decoration: none;
}

.consult-button {
    display: inline-block;
    padding: 6px 12px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid #fff;
    color: white;
    text-decoration: none;
}

.check-btn {
    width: 172px;
    height: 43px;
    line-height: 43px;
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
    border-radius: 5px;
    border: 1px solid #EBEBEB;
    cursor: pointer;

    &:hover {
        background: #007bff;
        color: white;
        border: 1px solid #007bff;
    }
}

.card-content {
    overflow: hidden;
    background: linear-gradient(rgba(196, 215, 255, 0.80), rgba(255, 255, 255, 1));
}
</style>